import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const DividerSpacer = styled.div`
  flex: 1;
  height: 1px;
  background-color: ${Tokens.ColorBorder};
`
